/* eslint-disable sonarjs/cognitive-complexity */
import * as Sebrae from '@sebrae/react-core';
import React from 'react';

import { BaSeButton, BaSeParagraph } from '@base/react';

import { useDisplay } from '../../hook/useDisplay';
import { Footer } from '../footer/footer';
import Header from '../header/header';
import { Button } from '../know-empretec/style';
import {
  Container,
  ContainerImage,
  ContainerInformations,
  Content,
  ContentImage,
  Wrapper,
} from './detail-empretec-style';

import { MAP_EMPRETEC } from '../../data/empretecData';

const getUrl = () => {
  const url = window.location.protocol + '//' + window.location.host;
  return url;
};

function DetailEmpretec() {
  const { isLargeDisplay } = useDisplay();

  const { getRouteParam, navigateTo } = Sebrae.useRouter();
  const [detailEmpretec, setDetailEmpretec] = React.useState();

  React.useEffect(() => {
    const moduleEmpretec = parseInt(getRouteParam('module') ?? 1);
    const empretecSelected = MAP_EMPRETEC.find(
      (e) => e.moduleId === moduleEmpretec,
    );
    if (!empretecSelected) {
      navigateTo(`${getUrl()}/portal`);
    }
    setDetailEmpretec(empretecSelected);
  }, [getRouteParam, navigateTo]);

  const handleClickBack = React.useCallback(() => {
    navigateTo(`${getUrl()}/portal`);
  }, [navigateTo]);

  return (
    <Container>
      <Header />
      <Wrapper>
        <Content bgColor={detailEmpretec?.bgColorInformations}>
          <ContainerInformations>
            <BaSeButton
              buttonType="button"
              color="#ffffff"
              leftIcon="arrow-left"
              loadingText="Carregando…"
              size="medium"
              type="tertiary"
              value="Voltar"
              onClick={handleClickBack}
              overrideColors={{
                foreground: '#fff',
              }}
            />
            <img
              src={detailEmpretec?.logoEmpretec}
              style={{
                width: '180px',
              }}
              alt="img-empretec"
            />

            {detailEmpretec?.detailDescription.map((item, index) =>
              typeof item === 'string' ? (
                <BaSeParagraph key={index} color="#fff">
                  {item}
                </BaSeParagraph>
              ) : (
                React.cloneElement(item, { key: index })
              ),
            )}

            <Button txtColor={detailEmpretec?.textColor}>
              Quero participar
            </Button>
          </ContainerInformations>

          <ContainerImage bgColorImage={detailEmpretec?.bgColor}>
            {isLargeDisplay() ? (
              <img
                src={detailEmpretec?.imgEmpretecLargeDisplay}
                alt="img-empre2ec"
              />
            ) : (
              <ContentImage>
                <img
                  src={detailEmpretec?.imgEmpretecSmallDisplay}
                  alt="img-empre2ec"
                />
              </ContentImage>
            )}
          </ContainerImage>
        </Content>
      </Wrapper>
      <Footer />
    </Container>
  );
}

export default DetailEmpretec;
